<template>
	<div class="m-product">
		<c-image v-if="unitData.show_banner == 1" class="m-product-advert" :src="unitData.banner_img" mode="widthFix"></c-image>
		<div v-if="unitData.show_title == 1" class="m-product-head flex-between-center">
			<div class="flex-center">
				<c-image v-if="unitData.title_img" class="image" :src="unitData.title_img" mode="heightFix"></c-image>
				<p>{{unitData.title_text}}</p>
			</div>
			<span v-if="unitData.more_link" class="more">{{unitData.more_text || '查看更多'}}</span>
		</div>
		<div class="m-product-list flex">
			<ul class="flex">
				<li v-for="(item, i) in unitData.product_list" :key="item.product_id">
					<c-image class="image" :src="item.product_img_url"></c-image>
					<p>￥{{item.sale_price}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product {
		border-radius: 10px;
		margin: 10px;
		overflow: hidden;
		background: #fff;
		
		&-head {
			height: 40px;
			padding: 0 12px;
			
			.image {
				height: 24px;
				margin-right: 6px;
			}
			
			p {
				font-size: 17px;
				font-weight: bold
			}
			
			.more {
				font-size: 12px;
				color: #999;
			}
		}
		
		&-list {
			margin: 6px 12px;
			overflow: hidden;
			
			ul {
				float: left;
				
				li {
					width: 90px;
					
					&:nth-child(n+2) {
						margin-left: 8px;
					}
					
					.image {
						height: 90px;
					}
					
					p {
						line-height: 32px;
						font-size: 14px;
						font-weight: bold;
					}
				}
			}
		}
	}
</style>
